import { useState, useEffect } from 'react';
import { NoRecords, PageLoader } from '../../lib/loader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ArrowDown, ArrowUp, BadgeCheck, BadgeMinus } from 'lucide-react';
import moment from 'moment';
import { useGetPrices, useUpdateFeeStatus } from './api/index';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';

function Chartcurrency() {

    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [sortOrder, setSortOrder] = useState('desc');
    const { data: getpriceList, isLoading, error } = useGetPrices({
        page: tempPage,
        size: tempRows,
        sortOrder: sortOrder,
        sortField: '_id',
    });

    const totalRecords = getpriceList?.data?.count || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const updateCoinStatus = useUpdateFeeStatus();


    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
    }, []);



    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'Chart currency' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };



    const list = () => {
        if (isLoading) {
            return <PageLoader />;
        }
        if (error) {
            return <div>Error loading data: {error.message}</div>;
        }
        if (!getpriceList?.data || getpriceList?.data?.length === 0) {
            return <NoRecords />;
        }
        return (
            <>
                {updateCoinStatus.isLoading &&
                    <PageLoader />}
                <div style={{ minHeight: '60vh' }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="fee management table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ maxWidth: '60px' }} align="center">
                                        S.NO
                                    </TableCell>
                                    <TableCell align="center">Currency Name</TableCell>
                                    <TableCell align="center">Currency Symbol</TableCell>
                                    <TableCell align="center">Image</TableCell>
                                    <TableCell align="center">Status</TableCell>

                                    <TableCell align="center">
                                        Updated Date & Time{' '}
                                        {sortOrder !== 'desc' ? (
                                            <ArrowUp
                                                onClick={() => setSortOrder('desc')}
                                                style={{ cursor: 'pointer' }}
                                                aria-label="Sort descending"
                                            />
                                        ) : (
                                            <ArrowDown
                                                onClick={() => setSortOrder('asc')}
                                                style={{ cursor: 'pointer' }}
                                                aria-label="Sort ascending"
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getpriceList?.data?.data?.map((row, i) => (
                                    <TableRow key={row._id}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">{row.name}</TableCell>
                                        <TableCell align="center">{row.symbol}</TableCell>
                                        <TableCell className="text-nowrap" align="center">
                                            {row?.image ? (
                                                <img
                                                    src={row.image}
                                                    alt="Currency Icon"
                                                    style={{
                                                        height: "30px",
                                                        width: "30px",
                                                        borderRadius: "50%",
                                                        verticalAlign: "middle",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            ) : (
                                                "-"
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.status ?
                                                <>
                                                    <BadgeCheck className='mx-auto' color='green' size={15} />
                                                    <span className='text-green-600'>Active</span>
                                                </> :
                                                <>
                                                    <BadgeMinus className='mx-auto' color='red' size={15} />
                                                    <span className='text-red-600'>Disabled</span>
                                                </>
                                            }
                                        </TableCell>

                                        <TableCell align="center">
                                            {moment(row.updatedAt).format('DD/MM/YYYY | hh:mm')}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        );
    };

    return (
        <>
            {access ?
                <div>
                    <h2>Chart Currency</h2>
                    <div className="ad_pg_bx bg-white">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                        </div>
                        {list()}
                    </div>
                </div>
                :
                <PermissionDenied />
            }

        </>
    );
}

export default Chartcurrency;